import { GRID_COLUMNS } from './types'
import type { DashboardWidget, WidgetPlacement } from './types'

/**
 * Раскладка дашборда после перетаскивания (#94).
 *
 * Перетаскивание меняет **порядок**, а места считаются из него укладкой слева направо по
 * двенадцати колонкам: виджет, не помещающийся в остаток ряда, переносится на следующий,
 * ряд по высоте — самый высокий в нём. Так раскладка не может оказаться «виджет на
 * виджете»: свободных координат, которые пользователь мог бы задать вразнобой, нет, а
 * сервер получает места всех виджетов одним запросом (`PUT /layout`) — сохранённая
 * наполовину раскладка и была бы наложением.
 *
 * Размеры не меняются: ширина и высота — поля виджета, их правит форма виджета.
 */
export function packLayout(widgets: Pick<DashboardWidget, 'id' | 'gridWidth' | 'gridHeight'>[]): WidgetPlacement[] {
  const placements: WidgetPlacement[] = []
  let x = 0
  let y = 0
  let rowHeight = 0
  for (const widget of widgets) {
    const width = Math.max(1, Math.min(GRID_COLUMNS, widget.gridWidth))
    const height = Math.max(1, widget.gridHeight)
    if (x + width > GRID_COLUMNS) {
      y += rowHeight
      x = 0
      rowHeight = 0
    }
    placements.push({ widgetId: widget.id, gridX: x, gridY: y, gridWidth: width, gridHeight: height })
    x += width
    rowHeight = Math.max(rowHeight, height)
  }
  return placements
}

/** Порядок, в котором виджет `moved` встал на место виджета `target`. */
export function moveBefore<T extends { id: string }>(items: T[], moved: string, target: string): T[] {
  if (moved === target) return items
  const from = items.findIndex((item) => item.id === moved)
  const to = items.findIndex((item) => item.id === target)
  if (from < 0 || to < 0) return items
  const next = [...items]
  const [item] = next.splice(from, 1)
  next.splice(to, 0, item!)
  return next
}
